import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "../sections/Footer";

export const Layout = () => (
  <div className="App bg-bg min-h-screen">
    <div className="grain" aria-hidden="true" />
    <Navbar />
    <main><Outlet /></main>
    <Footer />
  </div>
);
